/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpersConnectData = require('helpers/connectData');

var _helpersConnectData2 = _interopRequireDefault(_helpersConnectData);

var _reactRedux = require('react-redux');

var _reduxModulesSpecialSeries = require('redux/modules/specialSeries');

var _reduxModulesAdGroup = require('redux/modules/adGroup');

var _components = require('components');

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

// import sortBy from 'lodash/sortBy';

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashIsEmpty = require('lodash/isEmpty');

var _lodashIsEmpty2 = _interopRequireDefault(_lodashIsEmpty);

function fetchDataDeferred(getState, dispatch) {
	var promises = [];
	var state = getState();

	if (!_reduxModulesAdGroup.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesAdGroup.load(119078)));
	}

	if (!_reduxModulesSpecialSeries.isLoaded(state)) {
		promises.push(dispatch(_reduxModulesSpecialSeries.load()));
	}

	return _Promise.all(promises);
}

var SpecialSeries = (function (_Component) {
	_inherits(SpecialSeries, _Component);

	function SpecialSeries() {
		_classCallCheck(this, _SpecialSeries);

		_Component.apply(this, arguments);

		this.state = {
			limit: 20
		};
	}

	SpecialSeries.prototype.render = function render() {
		var _this = this;

		var styles = require('./SpecialSeries.css');
		var _props = this.props;
		var ads = _props.ads;
		var isSmallViewport = _props.isSmallViewport;
		var isMediumViewport = _props.isMediumViewport;

		// Show loading spinner while article is fetched
		if (this.props.loading || this.props.loading === undefined) {
			return _react2['default'].createElement(
				'main',
				{ className: styles.Base },
				_react2['default'].createElement(_reactLoader2['default'], {
					className: 'spinner',
					color: 'rgb(255, 78, 61)',
					corners: 0,
					direction: 1,
					hwaccel: true,
					left: '50%',
					length: 6,
					lines: 13,
					opacity: 0.1,
					radius: 7,
					rotate: 13,
					scale: 1.00,
					shadow: false,
					speed: 2,
					top: '50%',
					trail: 60,
					width: 2,
					zIndex: 2e9 })
			);
		}

		var adsBottom = _lodashFind2['default'](ads, function (ad) {
			return ad.position === 'bottom';
		});
		var adsBottomSquare = undefined;
		var adsBottomLeaderboard = undefined;
		if (!_lodashIsEmpty2['default'](adsBottom)) {
			// Get all 300×250 ads
			adsBottomSquare = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('300x250') > -1;
			});
			// Get all 728x90 ads
			adsBottomLeaderboard = _lodashFilter2['default'](adsBottom.ads, function (ad) {
				return ad.title.indexOf('728x90') > -1;
			});
		}

		var description = this.props.series.details.description;
		var series = this.props.series.results;
		var articleCount = series.length;

		var articles = _lodashMap2['default'](series, function (article, index) {
			var _classNames;

			if (index >= _this.state.limit) return false;

			var featureImage = article.image ? '' + _srcSettings2['default'].cdn + article.image : '' + _srcSettings2['default'].cdn + article.latestPost.images['bbrew-small'][0];
			var headerClasses = _classnames2['default']((_classNames = {}, _classNames[styles.ArticleHeader] = article.latestPost.images['bbrew-small'], _classNames[styles['ArticleHeader--noImage']] = !article.latestPost.images['bbrew-small'], _classNames));

			return _react2['default'].createElement(
				'div',
				{ key: article.id },
				adsBottomLeaderboard && adsBottomLeaderboard.length > 0 && index === articleCount / 2 && !isSmallViewport && !isMediumViewport && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomLeaderboard[0].url,
							ratio: '8x1',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomLeaderboard[0].image.src, alt: adsBottomLeaderboard[0].image.title })
					)
				),
				adsBottomSquare && adsBottomSquare.length > 0 && index === articleCount / 2 && (isSmallViewport || isMediumViewport) && _react2['default'].createElement(
					'section',
					{ className: styles.AdSpace },
					_react2['default'].createElement(
						_components.Ad,
						{
							className: styles.Ad,
							href: adsBottomSquare[0].url,
							ratio: '4x3',
							target: '_blank'
						},
						_react2['default'].createElement('img', { className: styles.Image, src: '' + _srcSettings2['default'].cdn + adsBottomSquare[0].image.src, alt: adsBottomSquare[0].image.title })
					)
				),
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.ArticleLink, to: '/special-series/' + article.slug },
					_react2['default'].createElement(
						'article',
						{ className: styles.Article },
						!isSmallViewport && article.latestPost.images['bbrew-small'] && _react2['default'].createElement(
							'figure',
							{ className: styles.ArticleFigure },
							_react2['default'].createElement('img', { src: featureImage })
						),
						_react2['default'].createElement(
							'header',
							{ className: headerClasses },
							_react2['default'].createElement(_components.MetaBar, {
								articleID: article.id,
								category: article.category,
								label: 'Most recent:',
								postDate: article.latestPost.post_date,
								specialSeries: article.specialSeries }),
							_react2['default'].createElement(
								'h1',
								{ className: styles.ArticleTitle },
								article.name
							),
							isSmallViewport && _react2['default'].createElement(
								'figure',
								{ className: styles.ArticleFigure },
								_react2['default'].createElement('img', { src: '' + _srcSettings2['default'].cdn + article.latestPost.images['bbrew-small'][0] })
							),
							_react2['default'].createElement('div', { className: styles.ArticleSnippet, dangerouslySetInnerHTML: { __html: article.description } })
						)
					)
				)
			);
		});

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Special Series' }),
			_react2['default'].createElement(
				'section',
				{ className: styles.SpecialSeries },
				_react2['default'].createElement(
					'figure',
					{ className: styles['Figure--featured'] },
					_react2['default'].createElement('img', { className: styles.FigureImage, src: '' + _srcSettings2['default'].cdn + series[0].featureImage })
				),
				_react2['default'].createElement(
					'header',
					{ className: styles.SectionHeader },
					_react2['default'].createElement(
						'h1',
						{ className: styles.Title },
						'Special Series'
					),
					_react2['default'].createElement(
						'p',
						{ className: styles.Intro },
						description
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Articles },
					articles
				),
				this.state.limit < articleCount && _react2['default'].createElement(
					'footer',
					{ className: styles.SectionFooter },
					_react2['default'].createElement(
						'button',
						{ className: styles.SeeMore, onClick: function (event) {
								event.preventDefault();
								_this.setState({
									limit: _this.state.limit + 20
								});
							} },
						'See More'
					)
				)
			)
		);
	};

	_createClass(SpecialSeries, null, [{
		key: 'propTypes',
		value: {
			ads: _react.PropTypes.array,
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			series: _react.PropTypes.oneOfType([_react2['default'].PropTypes.array, _react2['default'].PropTypes.object]),
			loading: _react.PropTypes.bool,
			location: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	var _SpecialSeries = SpecialSeries;
	SpecialSeries = _reactRedux.connect(function (state) {
		return {
			ads: state.adGroup.data,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport,
			loading: state.specialSeries.loading,
			series: state.specialSeries.data
		};
	})(SpecialSeries) || SpecialSeries;
	SpecialSeries = _helpersConnectData2['default'](null, fetchDataDeferred)(SpecialSeries) || SpecialSeries;
	return SpecialSeries;
})(_react.Component);

exports['default'] = SpecialSeries;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/SpecialSeries/SpecialSeries.js
 ** module id = 710
 ** module chunks = 0
 **/